import { render } from "./StatisticApexCount.vue?vue&type=template&id=a1328264&scoped=true"
import script from "./StatisticApexCount.vue?vue&type=script&lang=js"
export * from "./StatisticApexCount.vue?vue&type=script&lang=js"

import "./StatisticApexCount.vue?vue&type=style&index=0&id=a1328264&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\projects\\gvnpro\\supportgroup\\admin.supportgroup\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1328264"]])

export default __exports__